import { render, staticRenderFns } from "./ExternalTemplate.vue?vue&type=template&id=071ab94f&"
import script from "./ExternalTemplate.vue?vue&type=script&lang=ts&"
export * from "./ExternalTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports